<script setup lang="ts">
import { useQueryClient } from '@tanstack/vue-query'
import { ref } from 'vue'
import {
  registerInternationalPaymentAction,
  uploadInternationalPaymentReceiptAction,
} from '@/api/functions/transactions/transaction-receipt-upload.action'
import { useMutationApi } from '@/composables/useApi'
import { useToast } from '@/composables/useToast'
import { getErrorMessage } from '@/utils/errorUtils'
import TransactionReceiptUploader from '../partials/TransactionReceiptUploader.vue'

const props = defineProps({
  request: { type: Object, default: null },
  uuid: { type: String, default: '' },
  modelValue: { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const uploadedFiles = ref<any[]>([])

const toast = useToast()
const queryClient = useQueryClient()

const closeModal = () => {
  emit('update:modelValue', false)
  emit('cancel')
}

const resolveUuid = () => {
  return props.request && props.request.uuid ? props.request.uuid : props.uuid
}

const uploadMutation = useMutationApi({
  mutationFn: async () => {
    // if (!uploadedFiles.value || !uploadedFiles.value.length) {
    //   throw new Error('هیچ فایلی انتخاب نشده است')
    // }

    const images = uploadedFiles.value.map((f) => f.file)
    const uuidToUse = resolveUuid()
    if (!uuidToUse) {
      throw new Error('شناسه تراکنش پیدا نشد')
    }

    await uploadInternationalPaymentReceiptAction(uuidToUse, { images })
    await registerInternationalPaymentAction(uuidToUse)
  },

  onSuccess: () => {
    toast.success('رسید با موفقیت ارسال شد')
    const uuidToUse = resolveUuid()
    if (uuidToUse) queryClient.invalidateQueries({ queryKey: ['transaction', uuidToUse] })
    emit('confirm')
    closeModal()
  },

  onError: (err: Error) => {
    toast.error(getErrorMessage(err) || 'خطا در ارسال رسید')
  },
})

const confirmSave = () => {
  if (uploadMutation.isPending.value) return
  uploadMutation.mutate()
}
</script>

<template>
  <Modal :model-value="props.modelValue" @update:model-value="$emit('update:modelValue', $event)" width="600px"
    background="#FFF" :closable="true" title="پرداخت فروشنده" closeDirection="left" class="update-request">
    <form @submit.prevent="confirmSave" class="flex flex-col h-[400px]">
      <div class="flex-1 px-4 py-6 pb-9 space-y-1">
        <div>
          <TransactionReceiptUploader class="mt-4" @update:files="uploadedFiles = $event" />
        </div>
      </div>

      <div class="sticky bottom-0 bg-white z-50 flex justify-between gap-6 w-full pt-3 pb-9 px-2 border-gray-200">
        <Button type="submit" :isAdmin="true" :disabled="uploadMutation.isPending.value" class="w-9/12 h-12 rounded-xl">
          <span class="text-nowrap flex items-center justify-center gap-2">
            <img src="/svg/link-alt-svgrepo-white.svg" width="20" height="20" class="-rotate-45" />
            بارگذاری رسید فروشنده
          </span>
        </Button>

        <Button type="button" @click="closeModal" variant="outline" label="بازگشت" :isAdmin="true"
          class="w-4/12 h-12 rounded-xl border-2" />
      </div>
    </form>
  </Modal>
</template>

<style scoped></style>
